function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  padding: 8px 12px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  background-color: #f9f9f9;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  \n  &:hover {\n    background-color: #e8e8e8;\n    transform: translateX(4px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var ItemContainer = styled.div(_templateObject());
var RoadmapItem = function(param) {
    var label = param.label, onClick = param.onClick;
    return /*#__PURE__*/ React.createElement(ItemContainer, {
        onClick: onClick
    }, label);
};
export default RoadmapItem;
